import { EMOJI_REGEX } from "../constants";

export function stripEmojisFromString(sourceString: string) {
  return sourceString.replaceAll(EMOJI_REGEX, "");
}
